import { PlugCtr } from '@ecis/plugctr';

/* ECIS start */
var plugctr = new PlugCtr('kso');
/* ECIS end */

export { plugctr as default };
